"use client";

import generatedVariants from "./staticImageVariants.json";

type StaticImageLoaderProps = {
  src: string;
  width: number;
  quality?: number;
};

const responsiveVariants: Record<string, readonly number[]> = generatedVariants;

function variantPath(src: string, width: number) {
  return src.replace(/\.png$/i, `-w${width}.png`);
}

export default function staticImageLoader({ src, width }: StaticImageLoaderProps) {
  const widths = responsiveVariants[src];
  let candidate = src;

  if (widths?.length) {
    const largestWidth = widths[widths.length - 1];
    // Next's requested width already includes display density. Never advertise
    // a smaller export as that width while a sufficiently large source exists.
    const selectedWidth = widths.find((availableWidth) => availableWidth >= width) ?? largestWidth;
    candidate = selectedWidth === largestWidth ? src : variantPath(src, selectedWidth);
  }

  // The fragment distinguishes srcset entries without changing the static URL
  // requested from the server. Assets without variants keep their full source.
  return `${candidate}${candidate.includes("#") ? "&" : "#"}cv-width=${width}`;
}
